import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-vclaim";
import type { IfcPrepSep } from "@/types/bridging_bpjs";

async function prepSep(params: {
  rm: string;
  tgl: string;
  unit_id: string;
  dokter_id: string;
  username?: string;
}): Promise<IfcPrepSep> {
  const response = await http.postData("/prep-sep", params).catch(err => {
    console.log("exception catch", err);
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response.data;
}

async function prepAntrol(params: {
  rm: string;
  tgl: string;
  unit_id: string;
  dokter_id: string;
  jnsKunjungan?: string;
  dpjpSep?: string;
  poliTujuan?: string;
  diagnosa?: string;
  noRujukan?: string;
  noSrk?: string;
  dpjpSrk?: string;
  tglSrk?: string;
  username?: string;
}): Promise<IfcPrepSep> {
  const response = await http.postData("/prep-antrol", params).catch(err => {
    console.log("exception catch", err);
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response.data;
}

interface IfcPostSepAntrol {
  rm: string;
  telp: string;
  tgl: string;
  jnsKunjungan: string;
  dpjpSep: string;
  poliTujuan: string;
  diagnosa: string;
  noRujukan: string;
  noSrk: string;
  dpjpSrk: string;
  sendAntrol: boolean;
  username?: string;
}

async function postAntrolSep(
  //   params: {
  //   rm: string;
  //   tgl: string;
  //   jenis_kunjungan: string;
  //   nomor: string;
  // }
  params: IfcPostSepAntrol
) {
  const response = await http
    .postData("/pendaftaran-sep", params)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function postPAntrol(params: {
  prep_id: number;
  register: string;
  sendAntrol: boolean;
}) {
  const response = await http
    .postData("/pendaftaran-antrol", params)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

export default {
  prepSep,
  prepAntrol,
  postAntrolSep,
  postPAntrol
};
